export const styles = {
	box: {
		padding: '16px',
		border: '1px solid #eaebec',
		flexGrow: 1,
		display: 'flex',
		flexDirection: 'column',
		overflow: 'auto',
		position: 'relative'
	},
	memberTypesList: {
		flexGrow: 1
	},
	overlay: {
		position: 'absolute',
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		width: '100%',
		height: '100%',
		background: '#e3dfdf82',
		opacity: 0.5
	}
};
